import React, { useState } from 'react'
import { Snackbar, IconButton, Box } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

const ToastSnackbar = ({ snackbar }) => {
    const { severity = 'success', message = '', open = false } = snackbar
    const [isOpen, setIsOpen] = useState(open)

    const handleSnackbarClose = () => {
        setIsOpen(false)
        snackbar.open = false
        snackbar.message = ''
        snackbar.severity = 'success'
    };

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Box
                sx={{
                    backgroundColor: severity === 'success' ? '#4caf50' : '#f44336',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '300px'
                }}
            >
                <span style={{ marginRight: '8px' }}>
                    {severity === 'success' ? '✓' : '✗'}
                </span>
                <span style={{ flex: 1 }}>{message}</span>
                <IconButton
                    size="small"
                    style={{ color: 'white', marginLeft: '8px' }}
                    onClick={handleSnackbarClose}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
        </Snackbar>
    )
}

export default ToastSnackbar